


























import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { tns } from "tiny-slider/src/tiny-slider";
import lax from "lax.js";

// @ts-ignore
import VClamp from "vue-clamp";

@Component({
    components: {
        VClamp
    }
})
export default class TestimonialFloater extends Vue {
    @Prop() testimonials: any;

    @Prop({ required: false, default: false }) serviceId?: number | false;

    @Prop({ required: false, default: false }) bw?: boolean;

    @Ref() readonly sliderTestimonials!: HTMLElement;

    slider: any = null;

    localTestimonials: any = [];

    async mounted() {
        if (this.serviceId && (!this.testimonials || this.testimonials.length === 0)) {
            await this.getTestimonials();
        } else {
            this.localTestimonials = this.testimonials;
        }

        // @ts-ignore
        if (this.$mq === "sm" || this.$mq === "md" || this.$mq === "lg" || this.$mq === "xl") {
            this.initSlider();
        } else {
            setTimeout(() => this.initAnimation(), 1000);
        }
    }

    async getTestimonials() {
        // @ts-ignore
        const response = await axios.get("/api/testimonials", { params: { per_page: 3, service: this.serviceId } });

        this.localTestimonials = response.data.data;
    }

    initAnimation() {
        this.$nextTick(() => {
            lax.addElements(".testimonial-card", {
                scrollY: {
                    translateY: [
                        ["elInY-50", "elCenterY-elHeight+25", "elOutY-elHeight"],
                        [0, -200, -400]
                    ],
                    translateX: [
                        ["elInY-50", "elCenterY-elHeight+25", "elOutY-elHeight"],
                        [0, -150, 0]
                    ],
                    opacity: [
                        ["elInY", "elCenterY-elHeight+25", "elOutY-elHeight"],
                        [0, 1, 0]
                    ]
                }
            });
        });
    }

    initSlider() {
        this.$nextTick(() => {
            // @ts-nocheck
            this.slider = tns({
                container: this.sliderTestimonials,
                items: 1.1,
                gutter: 24,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                swipeAngle: false,
                nav: false,
                responsive: {
                    768: {
                        items: 2.1,
                        gutter: 24
                    },
                    1440: {
                        items: 2.9,
                        gutter: 24
                    }
                }
            });
        });
    }
}
